export default "__VITE_ASSET__DSFeZZWU__"